import { createRepository } from '@/shared/repositories/Repository'
import { BASE_URL, PRIVACY_POLICY_PATH } from '@/shared/api'
import type { PrivacyPolicyResponse } from '../model/types'

const policyRepository = createRepository({
  basePath: BASE_URL,
  useAuth: false
})

export const getPrivacyPolicy = () => {
  return policyRepository.get<PrivacyPolicyResponse>(
    PRIVACY_POLICY_PATH,
    undefined,
    {
      404: 'Политика конфиденциальности не найдена',
      500: 'Ошибка при загрузке политики конфиденциальности'
    }
  )
}
